var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading bg-bgcontainer w-100 h-100 position-absolute d-flex flex-column align-items-center justify-content-center text-secondary"},[_c('b-spinner',{staticClass:"spinner"}),_c('div',{staticClass:"loading-text mt-3"},[_vm._v(_vm._s(_vm.loadingText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }